<template>
  <div v-loading.body="loading">
    <el-menu
      :default-active="$route.path"
      class="el-menu-demo"
      mode="horizontal"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#409EFF"
      router
    >
      <el-menu-item index="/home/wavepicking/wavepickinglist"
        >波次单列表</el-menu-item
      >
      <el-menu-item index="/home/aswavepicking/aswavepickinglist"
        >售后波次</el-menu-item
      >
      <el-menu-item index="/home/wavepicking/TempSummaryList/5"
        >质检汇总</el-menu-item
      >
      <el-menu-item index="/home/wavepicking/TempSummaryList/6"
        >改标汇总</el-menu-item
      >
      <el-menu-item index="/home/surpassSummary/surpassSummaryPickingList"
        >中分汇总拣货</el-menu-item
      >
    </el-menu>
    <el-row class="tab-div">
      <div class="block">
        <span class="demonstration">汇总状态统计：</span>
        <el-date-picker
          v-model="form2.fresh_date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期时间"
        >
        </el-date-picker>
        <el-button
          type="primary"
          style="margin-left: auto"
          size="mini"
          @click="freshData()"
          >刷新</el-button
        >
        <el-tag class="tag-css" style="margin-left: 20px">
          商品数量（{{ countData.goods_num }}）</el-tag
        >
        <el-tag class="tag-css"
          >点货分离（{{ countData.quality_label_dabiao_num }}）</el-tag
        >
        <el-tag class="tag-css">已拣货（{{ countData.picking_num }}）</el-tag>
        <el-tag class="tag-css"
          >待拣货（{{ countData.wait_picking_num }}）</el-tag
        >
        <el-tag class="tag-css"
          >待生成拣货（{{ countData.wait_create_picking_num }}）</el-tag
        >
      </div>
    </el-row>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="输入搜索：">
                    <el-input
                      v-model="form.summary_id"
                      placeholder="汇总id"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.wave_picking_no"
                      placeholder="波次号"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_full_allot"
                      placeholder="是否全部配齐"
                    >
                      <el-option
                        v-for="item in is_full_allot"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_picking_full"
                      placeholder="是否全部生成拣货任务"
                    >
                      <el-option
                        v-for="item in is_picking_full"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.is_lock" placeholder="是否已锁定">
                      <el-option
                        v-for="item in is_lock"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-if="form.type == 5"
                      v-model="form.is_remark"
                      placeholder="是否有备注"
                    >
                      <el-option
                        v-for="item in is_remark"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-if="form.type == 5"
                      v-model="form.is_have_remark_wave"
                      placeholder="无备注汇总是否包含有备注波次"
                    >
                      <el-option
                        v-for="item in is_have_remark_wave"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="创建时间：">
                    <el-date-picker
                      v-model="form.create_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :default-time="['06:00:00', '06:00:00']"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="更新时间：">
                    <el-date-picker
                      v-model="form.update_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :default-time="['06:00:00', '06:00:00']"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="最后配货时间：">
                    <el-date-picker
                      v-model="form.last_allot_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :default-time="['06:00:00', '06:00:00']"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="reset">重置</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="search">查询</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <el-row
          :span="24"
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-col :span="8">数据列表：</el-col>
          <el-col :span="16" style="text-align: right">
            <el-button
              v-if="form.type == 6"
              type="danger"
              style="margin-left: auto"
              size="mini"
              @click="printAll"
              >打印配货单</el-button
            >

            <el-dropdown
              style="margin-left: 10px"
              size="mini"
              split-button
              type="primary"
              @click="createTask(0)"
              @command="createTask"
            >
              生成拣货任务
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1"
                  >全部生成拣货任务</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <!--<el-button type="danger" style="margin-left: auto;" size="mini"  @click="createTask()">生成拣货任务</el-button>-->
            <el-button
              type="danger"
              style="margin-left: 10px"
              size="mini"
              @click="lockSummary()"
              >锁定汇总</el-button
            >
            <el-button type="primary" style="" size="mini" @click="output(1)">
              导出</el-button
            >
            <el-button type="primary" style="" size="mini" @click="output(2)">
              导出明细</el-button
            >
          </el-col>
        </el-row>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="right"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              prop="quality_label_summary_id"
              label="汇总id"
            ></el-table-column>
            <!--<el-table-column prop="sort_no" label="序号" align="center"></el-table-column>-->
            <el-table-column
              prop="quality_label_goods_num"
              label="分离数"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="picking_goods_num"
              label="已拣数量"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_num"
              label="所需数量"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="today_full_allot_wave_num"
              label="今日配齐波次数"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="full_allot_wave_num"
              label="配齐波次数量"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="wave_num"
              label="波次数量"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="生成时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="update_time"
              label="更新时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="last_allot_time"
              label="最后配货时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="is_full_allot"
              label="是否全部配齐"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="is_picking_full"
              label="是否全部生成拣货任务"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="is_lock"
              label="是否锁定"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="form.type == 5"
              prop="is_remark"
              label="是否有备注汇总"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="form.type == 5"
              prop="is_have_remark"
              label="无备注汇总是否包含有备注波次"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >{{ scope.row.is_have_remark }}</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              show-overflow-tooltip
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="opendeatail(scope.row)"
                  >查看明细</el-button
                ><br />
                <el-button
                  type="text"
                  size="small"
                  @click="unlockSummary(scope.row)"
                  >解锁汇总</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="resData.current_page"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.total"
            :page-size="form.pagesize"
            :page-sizes="[20, 100, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  directives: {
    focus: {
      // 当绑定元素插入到 DOM 中。
      inserted(el) {
        // 聚焦元素
        el.children[0].focus();
      },
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: {
        setting: "未配置数据",
      },
      countData: {},
      conditionData: {},
      cityData: {},
      districtData: {},
      form: {
        create_time: this.$excalibur.getDateTimeOnHours(-15, 6),
        multipleSelection: [],
        pagesize: 20,
        type: this.$route.params.id,
        // dbid:'',
      },
      form2: {
        fresh_date: this.today(),
      },
      co_img: "",
      loading: false,
      url: "/erp/WavePickingTempSummary/qlSummaryList",
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      checkVisible: false,
      msgVisible: false,
      msg: "",
      param: "",
      is_summary: 0, // 勾选的是否有汇总单的数据
      is_full_allot: [
        { key: "", name: "全部" },
        { key: 2, name: "否" },
        { key: 1, name: "是" },
      ],
      is_picking_full: [
        { key: "", name: "全部" },
        { key: 2, name: "否" },
        { key: 1, name: "是" },
      ],
      is_lock: [
        { key: "", name: "全部" },
        { key: 2, name: "未锁定" },
        { key: 1, name: "已锁定" },
      ],
      is_remark: [
        { key: "", name: "全部" },
        { key: 2, name: "否" },
        { key: 1, name: "是" },
      ],
      is_have_remark_wave: [
        { key: "", name: "全部" },
        { key: 2, name: "否" },
        { key: 1, name: "是" },
      ],

      shippingAction: "",
      shippingVisible: false,
      all_num: 0,
      check_num: 0,
      websock: null,
      focusState: true,
      is_remark_wavepicking: "",
      origin: 1,
      multipleSelection: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  created() {
    this.fetchData();
  },
  destroyed() {},
  methods: {
    spaceUp() {
      this.msgVisible = false;
      return false;
    },

    handleSizeChange($val) {
      this.form.pagesize = $val;
      this.fetchData(true);
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 15);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    searchDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 15);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    today() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;
      return end;
    },
    output(val) {
      this.form.is_excel = val;
      if (this.form.is_excel == 2) {
        if (this.form.multipleSelection.length == 0) {
          this.$message.e("请勾选汇总");
          this.loading = false;
          return false;
        }
      }
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
        } else {
          this.loading = false;
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },

    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      this.is_summary = 0;
      for (const key in val) {
        multipleSelection[key] = val[key].quality_label_summary_id;
      }
      this.form.multipleSelection = multipleSelection;
      this.multipleSelection = multipleSelection;
      console.log(multipleSelection);
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    // handleClick(row) {
    //   let param_type = 0;
    //   if (row.ts_type == 2) {
    //     param_type = 2;
    //   } else if (row.ts_type == 3) {
    //     param_type = 3;
    //   }
    //   this.$router.push({
    //     path: "/home/wavepicking/wavepickinglist/",
    //     name: "WavePickingList",
    //     params: {
    //       type: param_type,
    //       temp_summary_no: row.temp_summary_no,
    //     },
    //   });
    // },
    handleToSummary(row) {
      this.$router.push({
        path: "wavepicking/lockwavepickinglist/3",
        name: "LockWavePickingList",
        params: {
          summary_no: row.temp_summary_no,
          is_many: 3,
        },
      });
    },

    opendeatail(row) {
      this.checkVisible = false;
      this.$router.push(
        `/home/wavepicking/qlsummarydetail/${row.quality_label_summary_id}`
      );
    },

    search() {
      this.form.page = 1;
      this.form.is_excel = 0;
      this.loading = true;
      if (this.form.type == 5) {
        this.filteredForm.ts_type = 2;
      } else {
        this.filteredForm.ts_type = 3;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
          this.resData = res.data.data;
        } else {
          this.resData = res.data.data;
          this.curPage = 1;
        }
      });
    },
    selectOrigin(key) {
      this.form.origin = this.origin = key;
      this.loading = true;

      this.fetchData(true);
    },
    selectType(key) {
      this.form.type = this.type = key;
      this.loading = true;
      this.fetchData(true);
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      if (this.form.type == 5) {
        this.filteredForm.ts_type = 2;
      } else {
        this.filteredForm.ts_type = 3;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.origin = this.resData.origin;
          this.splitData(this.resData);
        }
      });
      this.freshData();
    },
    freshData() {
      if (this.form.type == 5) {
        this.filteredForm.ts_type = 2;
      } else {
        this.filteredForm.ts_type = 3;
      }
      this.$http
        .post(this.url, {
          ts_type: this.filteredForm.ts_type,
          fresh_date: this.form2.fresh_date,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.countData = res.data.data;
          }
        });
    },
    splitData(val) {
      for (const key in val.data) {
        this.resData.data[key].order_sn =
          val.data[key].order_sn && val.data[key].order_sn.split("\r\n");
        this.resData.data[key].custom_note =
          val.data[key].custom_note && val.data[key].custom_note.split("\r\n");
        this.resData.data[key].admin_note =
          val.data[key].admin_note && val.data[key].admin_note.split("\r\n");
      }
    },

    lockSummary() {
      // if(this.form.multipleSelection.length == 0){
      //     this.$message.e("请勾选汇总");
      //     return false
      // }
      const lock_url = "/erp/WavePickingTempSummary/LockQlSummary";
      this.$confirm("确定锁定汇总吗", "提示", {
        confirmButtonText: "确定",
        closeOnClickModal: false,
        type: "warning",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          if (this.form.type == 5) {
            this.filteredForm.ts_type = 2;
          } else {
            this.filteredForm.ts_type = 3;
          }
          this.$http.post(lock_url, this.filteredForm).then((res2) => {
            if (res2.data.code !== 200) {
              this.$message({
                type: "error",
                message: res2.data.msg,
              });
            } else {
              this.$message({
                type: "success",
                message: "处理成功!",
              });
              this.fetchData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    unlockSummary(val) {
      const unlock_url = "/erp/WavePickingTempSummary/unlockQlSummary";
      this.$confirm("确定要解锁汇总?", "提示", {
        confirmButtonText: "确定",
        closeOnClickModal: false,
        type: "warning",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.$http
            .post(unlock_url, {
              quality_label_summary_id: val.quality_label_summary_id,
            })
            .then((res2) => {
              if (res2.data.code !== 200) {
                this.$message({
                  type: "error",
                  message: res2.data.msg,
                });
              } else {
                this.$message({
                  type: "success",
                  message: "处理成功!",
                });
                this.fetchData();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    createTask(val) {
      console.log(val);
      if (val == 1) {
        this.filteredForm.is_zjgb_last = 1;
      } else {
        this.filteredForm.is_zjgb_last = 0;
      }
      if (this.form.type == 5) {
        // 质检
        this.filteredForm.generate_type = 2;
      } else {
        // 改标
        this.filteredForm.generate_type = 3;
      }
      if (this.form.multipleSelection.length != 0) {
        this.filteredForm.the_ids = this.form.multipleSelection;
      }
      const url = "/erp/PickingAssignment/generatePickingAssignment";
      this.$confirm("确定要生成拣货任务?", "提示", {
        confirmButtonText: "确定",
        closeOnClickModal: false,
        type: "warning",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.$http.post(url, this.filteredForm).then((res2) => {
            if (res2.data.code !== 200) {
              this.$message({
                type: "error",
                message: res2.data.msg,
              });
            } else {
              const showCancelButton = false;
              this.$confirm(res2.data.msg, "拣货任务生成结果", {
                showCancelButton,
              });
              this.fetchData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    split_arr(str) {
      let strs = new Array(); // 定义一数组
      strs = str.split(","); // 字符分割
      let new_arr = "";
      for (let i = 0; i < strs.length; i++) {
        new_arr = `${new_arr + strs[i]}<br/>`; // 分割后的字符输出
      }
      return new_arr;
    },
    reset() {
      this.form = {};
      this.form.page = 1;
      this.form.create_time = this.searchDate();
      this.form.type = this.$route.params.id;
      this.form.multipleSelection = this.multipleSelection;
      this.form.pagesize = 10;
    },
    handleClick(row) {
      if (row.is_have_remark == "否") {
        return false;
      }
      let status = 1;
      if (row.is_lock == "是") {
        status = 10;
      }
      this.$router.push({
        path: "/home/wavepicking/wavepickinglist/",
        name: "WavePickingList",
        params: {
          quality_label_summary_id: row.quality_label_summary_id,
          status,
        },
      });
    },
    // 打印配货单
    printAll() {
      if (this.multipleSelection.length == 0) {
        return this.$message.e("请选择汇总进行打印");
      }
      console.log(this.$route, this.$router);
      const id = this.multipleSelection.join(",");
      window.open(`#/wavepickingsummary/printall/${id}`);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.tab-div {
  border: 1px solid #ddd;
  margin: 20px 0;
  padding: 10px 0 10px 20px;
}

.tag-css {
  margin-left: 10px;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.el-dropdown-menu__item {
  background-color: #f56c6c;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/TempSummaryList.vue